<script>
    export let _click = () => {};
</script>

<div id='open-map-button' on:click={_click}>
    展廳地圖 Gallery Layout
</div>

<style type='text/scss'>
    #open-map-button {
        width: fit-content;
        position: relative;
        align-self: center;
        background: linear-gradient(180deg, #004a8f 30% ,  #003366 70%);
        color: white;
        border-radius: 20px;
        text-align: center;
        padding: 6px 30px;
        white-space: nowrap;

        img {
            width: 100%;
        }
    }
</style>